import axios from '../axios'
import Qs from 'qs'
// 查询banner
export const queryBanner = data => {
  return axios({
    url: '/match/websiteMain//queryBanner/1',
    method: 'get',
    headers: {
      isToken: false
    }
  })
}

// 查询置顶公告 {agencyId}
export const topNotices = data => {
  return axios({
    url: '/match/websiteMain//topNotices/1',
    method: 'get',
    headers: {
      isToken: false
    }
  })
}

// 查询首页总览数据{agencyId}
export const queryTotalData = data => {
  return axios({
    url: '/match/websiteMain/queryTotalData/1',
    method: 'get',
    headers: {
      isToken: false
    }
  })
}
// 查询主办方项目{agencyId}
export const queryAgencyProgram = data => {
  return axios({
    url: '/match/websiteMain/queryAgencyProgram/1',
    method: 'get',
    headers: {
      isToken: false
    }
  })
}

// 查询文章类型{agencyId}
export const articleType = data => {
  return axios({
    url: '/match/websiteMain/type/1',
    method: 'get',
    headers: {
      isToken: false
    }
  })
}

// 按类型查询文章列表 {agencyId}/{pageNum}/{pageSize}/{typeId}
export const listByType = data => {
  // if (data.id === 0) {
  //   return axios({
  //     url: '/match/websiteMain/pageQueryNotices/1/' + data.pageNum + '/' + data.pageSize,
  //     method: 'get',
  //     headers: {
  //       isToken: false
  //     }
  //   })
  // } else {
  return axios({
    url: '/match/websiteMain/listByType/1/' + data.pageNum + '/' + data.pageSize + '/' + data.id,
    method: 'get',
    headers: {
      isToken: false
    }
  })
  // }
}

// 查询文章详情 {id}
export const findDetailById = data => {
  return axios({
    url: '/match/websiteMain/findDetailById/' + data.id,
    method: 'get',
    headers: {
      isToken: false
    }
  })
}

// 赛事页面子菜单
export const queryMatchProgramType = data => {
  return axios({
    url: '/match/website/queryMatchProgramType',
    method: 'get',
    headers: {
      isToken: false
    }
  })
}

// 赛事列表 {agencyId}/{pageNum}/{pageSize}{matchType}/{programType}
export const websitePageMatchList = data => {
  return axios({
    url: '/match/website/websitePageMatchList/1/' + data.pageNum + '/' + data.pageSize + '/' + data.matchType + '/' + data.programType,
    method: 'get',
    headers: {
      isToken: false
    }
  })
}

// 个人中心机构
export const myAgencyList = data => {
  return axios({
    url: '/agency/agencyInfo/high/list/' + data.accountId,
    method: 'get'
  })
}

// 个人中修改基本资料
export const modification = data => {
  return axios({
    url: '/auth/self/modification',
    method: 'put',
    data
  })
}

// 个人中心注册机构
export const registerAgency = data => {
  return axios({
    url: '/agency/agencyMatch/matchRegister',
    method: 'post',
    data
  })
}

// 个人中心修改机构信息
export const updateAgency = data => {
  return axios({
    url: '/agency/agencyInfo/update',
    method: 'post',
    data
  })
}

// 个人中心查询注册项目
export const programAgency = data => {
  return axios({
    url: '/match/programAgency/list/1',
    method: 'get'
  })
}

// 个人中心查询授权机构的权限
export const agencyPermission = data => {
  return axios({
    url: '/agency/permission/home/manage/' + data.agencyId,
    method: 'get'
  })
}

// 个人中心授权管理查询
export const personalCenter = data => {
  return axios({
    url: '/agency/agencyAccount/personalCenter/' + data.agencyId,
    method: 'post',
    data
  })
}

// 个人中心删除子账号
export const delSubaccount = data => {
  return axios({
    url: '/agency/agencyAccount/personalCenter/del/' + data.agencyId + '/' + data.accountId,
    method: 'get'
  })
}

// 个人中心验证手机号码是否注册
export const verifyRegister = data => {
  return axios({
    url: '/auth/verify/register/' + data.account,
    method: 'get'
  })
}

// 个人中心账号注册
export const accountRegister = data => {
  return axios({
    url: '/auth/agency/register',
    method: 'put',
    data
  })
}

// 个人中心授权子账号
export const addOrUpSubaccount = data => {
  return axios({
    url: '/agency/agencyAccount/personalCenter/add/subaccount',
    method: 'post',
    data
  })
}

// 查询审核资料
export const agencyUnitMaterial = data => {
  return axios({
    url: '/athlete/unit/areaAgency/by/1/' + data.agencyId,
    method: 'get'
  })
}

// 申请成为注册机构
export const applyRegisterAgency = data => {
  return axios({
    url: '/athlete/unit/areaAgency/settleIn',
    method: 'post',
    data
  })
}

// 查询注册运动员列表
export const athleteBasicList = data => {
  return axios({
    url: '/athlete/basic/by/areaAgency/list',
    method: 'post',
    headers: {
      'Content-Type': 'application/x-www-form-urlencoded '
    },
    data: Qs.stringify(data)
  })
}

// 查询审核资料
export const athleteBasicInfo = data => {
  return axios({
    url: '/athlete/basic/byid/1/' + data.athleteId,
    method: 'get'
  })
}

// 查询队员列表
export const matchPlayerList = data => {
  return axios({
    url: '/match/player/list/' + data.agencyId + '/' + data.pageNum + '/' + data.pageSize + data.query,
    method: 'get'
  })
}

// 查询账号队员列表
export const personalPlayerList = data => {
  return axios({
    url: '/match/player/personalPlayerList',
    method: 'get'
  })
}

/**
 * 查询个人中心团队管理
 * @param {*} data
 */
export const agencyStaffList = data => {
  return axios({
    url: '/agency/agencyStaff/coachList/' + data.agencyId + '/' + data.pageNum + '/' + data.pageSize + data.query,
    method: 'get'
  })
}

// 新增运动员注册项目
export const athleteAffectSave = data => {
  return axios({
    url: '/athlete/affect/save',
    method: 'post',
    data
  })
}



// WEBPACK FOOTER //
// ./src/comm/http/modules/high.js